import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'GoodUnited',
    description: 'The GoodUnited design system: semantic colors, typography, components, charts, blocks and templates, built from the GoodUnited Figma file.',
    placeholder: 'The GoodUnited design system.',
    url: getOrigin()
}